const routes = {
    HOME: '/',
    PROCEEDING: '/expediente',
    SEARCH: jurisdiction => (`/${jurisdiction}/buscador`),
    HISTORY: (jurisdiction, number) =>  (`/${jurisdiction}/expediente/${number}/historia`),
    MY_PROCEEDINGS: '/mis-expedientes',
  };
  
export default routes;  